import { Component } from '@angular/core';
import { Intercom } from '@supy-io/ngx-intercom';
import { BsChatService } from '@brightside-web/desktop/data-access/core-services';

@Component({
    selector: 'brightside-web-helping-hands',
    templateUrl: './helping-hands.component.html',
    styleUrls: ['./helping-hands.component.scss'],
    standalone: false
})
export class HelpingHandsComponent {
  constructor(private _bsChatService: BsChatService) {}

  openChat() {
    this._bsChatService.showChat();
  }
}
